import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'
import it00001 from '../images/terko/00001.jpg'
import it00002 from '../images/terko/00002.jpg'
import it00003 from '../images/terko/00003.jpg'
import it00004 from '../images/terko/00004.jpg'
import it00005 from '../images/terko/00005.jpg'
import it00006 from '../images/terko/00006.jpg'
import it00007 from '../images/terko/00007.jpg'
import i00001 from '../images/komuves-homlokzat/00001.jpg'
import i00002 from '../images/komuves-homlokzat/00002.jpg'
import i00004 from '../images/komuves-homlokzat/00004.jpg'
import i00005 from '../images/komuves-homlokzat/00005.jpg'
import i00006 from '../images/komuves-homlokzat/00006.jpg'
import i00007 from '../images/komuves-homlokzat/00007.jpg'
import i00008 from '../images/komuves-homlokzat/00008.jpg'
import i00009 from '../images/komuves-homlokzat/00009.jpg'
import i00010 from '../images/komuves-homlokzat/00010.jpg'
import i00011 from '../images/komuves-homlokzat/00011.jpg'
import i00012 from '../images/komuves-homlokzat/00012.jpg'
import i00013 from '../images/komuves-homlokzat/00013.jpg'
import i00014 from '../images/komuves-homlokzat/00014.jpg'
import i00015 from '../images/komuves-homlokzat/00015.jpg'
import i00016 from '../images/komuves-homlokzat/00016.jpg'
import i00017 from '../images/komuves-homlokzat/00017.jpg'
import i00018 from '../images/komuves-homlokzat/00018.jpg'
import i00019 from '../images/komuves-homlokzat/00019.jpg'
import i00020 from '../images/komuves-homlokzat/00020.jpg'
import i00021 from '../images/komuves-homlokzat/00021.jpg'
import i00022 from '../images/komuves-homlokzat/00022.jpg'
import i00023 from '../images/komuves-homlokzat/00023.jpg'
import i00024 from '../images/komuves-homlokzat/00024.jpg'
import i00025 from '../images/komuves-homlokzat/00025.jpg'
import i00026 from '../images/komuves-homlokzat/00026.jpg'
import i00027 from '../images/komuves-homlokzat/00027.jpg'
import i00028 from '../images/komuves-homlokzat/00028.jpg'
import i00029 from '../images/komuves-homlokzat/00029.jpg'
import i00030 from '../images/komuves-homlokzat/00030.jpg'
import i00031 from '../images/komuves-homlokzat/00031.jpg'
import i00032 from '../images/komuves-homlokzat/00032.jpg'
import i00033 from '../images/komuves-homlokzat/00033.jpg'
import i00034 from '../images/komuves-homlokzat/00034.jpg'
import i00035 from '../images/komuves-homlokzat/00035.jpg'
import i00036 from '../images/komuves-homlokzat/00036.jpg'
import i00037 from '../images/komuves-homlokzat/00037.jpg'
import i00038 from '../images/komuves-homlokzat/00038.jpg'
import i00039 from '../images/komuves-homlokzat/00039.jpg'
import i00040 from '../images/komuves-homlokzat/00040.jpg'
import i00041 from '../images/komuves-homlokzat/00041.jpg'
import i00042 from '../images/komuves-homlokzat/00042.jpg'
import i00043 from '../images/komuves-homlokzat/00043.jpg'
import i00044 from '../images/komuves-homlokzat/00044.jpg'
import i00045 from '../images/komuves-homlokzat/00045.jpg'
import i00046 from '../images/komuves-homlokzat/00046.jpg'
import i00047 from '../images/komuves-homlokzat/00047.jpg'
import i00048 from '../images/komuves-homlokzat/00048.jpg'
import i00049 from '../images/komuves-homlokzat/00049.jpg'
import i00050 from '../images/komuves-homlokzat/00050.jpg'
import i00051 from '../images/komuves-homlokzat/00051.jpg'
import i00052 from '../images/komuves-homlokzat/00052.jpg'
import i00053 from '../images/komuves-homlokzat/00053.jpg'
import i00054 from '../images/komuves-homlokzat/00054.jpg'
import i00055 from '../images/komuves-homlokzat/00055.jpg'
import i00056 from '../images/komuves-homlokzat/00056.jpg'
import i00057 from '../images/komuves-homlokzat/00057.jpg'
import i00058 from '../images/komuves-homlokzat/00058.jpg'
import i00059 from '../images/komuves-homlokzat/00059.jpg'
import i00060 from '../images/komuves-homlokzat/00060.jpg'
import i00061 from '../images/komuves-homlokzat/00061.jpg'
import i00062 from '../images/komuves-homlokzat/00062.jpg'
import i00063 from '../images/komuves-homlokzat/00063.jpg'
import i00064 from '../images/komuves-homlokzat/00064.jpg'
import i00065 from '../images/komuves-homlokzat/00065.jpg'
import i00066 from '../images/komuves-homlokzat/00066.jpg'
import i00067 from '../images/komuves-homlokzat/00067.jpg'
import i00068 from '../images/komuves-homlokzat/00068.jpg'
import i00069 from '../images/komuves-homlokzat/00069.jpg'
import i00070 from '../images/komuves-homlokzat/00070.jpg'
import i00071 from '../images/komuves-homlokzat/00071.jpg'
import i00072 from '../images/komuves-homlokzat/00072.jpg'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,
    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Kőműves munkák</Title>
        <p>
          A mi cégünknek az egyik erénye, hogy mindent megbeszélünk az ügyfelekkel. Mindenbe bevonjuk az ügyfeleinket,
          nem csinálunk meg semmit az előzetes beleegyezése nélkül. Kőművesre van, szüksége válasszon minket! A mi
          szakembereink pontosak, megbízhatóak, és precízek. Munkánkra teljes körű garanciát adunk. Amennyiben kőműves
          munkára lenne szüksége, ha szeretné átalakítani otthonát, ha újítani akarna, ha bővíteni akarna, akkor hívjon
          minket, és mi az előzetes konzultáció után neki is látunk a feladatnak. Tisztán és precízen dolgozunk!
        </p>
        <p>Válasszon az alábbiak közül:</p>
        <ul>
          <li>
            <a href="#belteri-munkak">Beltéri munkák</a>
          </li>
          <li>
            <a href="#kulteri-munkak">Kültéri munkák</a>
          </li>
          <li>
            <a href="#estrich">Estrich betonozás</a>
          </li>
          <li>
            <a href="#falszigeteles">Utólagos falszigetelések</a>
          </li>
          <li>
            <a href="#veszelytelenites">Homlokzat veszélytelenítés, felújítás és karbantartási munkák</a>
          </li>
          <li>
            <a href="#kepek">Képek</a>
          </li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="belteri-munkak">Beltéri munkák</SubTitle>
        <ul>
          <li>Gipszkarton</li>
          <li>Festés</li>
          <li>Beltéri kőműves munkák</li>
          <li>Belső szigetelés</li>
          <li>Csempézés</li>
          <li>Egyéb beltéri munkák</li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="kulteri-munkak">Kültéri munkák</SubTitle>
        <ul>
          <li>Burkolókövek</li>
          <li>Külső szigetelés</li>
          <li>Utólagos külső szigetelés</li>
          <li>Ács munkák</li>
          <li>Csatorna kivitelezés</li>
          <li>Bádogozás és javítás</li>
          <li>Kémény építés, javítás</li>
          <li>Festés</li>
          <li>Burkoló munkák</li>
          <li>Medencék</li>
          <li>Kőműves munkák</li>
          <li>Lapostető szigetelés</li>
          <li>Viakolor lerakás</li>
          <li>Térkő lerakás</li>
          <li>Egyéb kültéri építőipari munkák</li>
        </ul>
      </Section>
      <Section>
        <SubTitle>Képek</SubTitle>
        <Images>
          <img src={it00001} alt="" />
          <img src={it00002} alt="" />
          {/* <img src={it00003} alt="" /> */}
          <img src={it00004} alt="" />
          <img src={it00005} alt="" />
          <img src={it00006} alt="" />
          <img src={it00007} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Section>
        <SubTitle id="estrich">Estrich betonozás</SubTitle>
        <p>
          Esztrich alatt egy speciális aljzatbeton réteget értünk melynek vastagsága általában 2- 8 cm között változik.
          Ezt a réteget földnedves, vagy képlékeny formában dolgozzuk be. Az estrich aljzattal tökéletesen sima
          felületet érünk el, így nincs szükség kiegyenlítő, vagy kötő rétegre. Ezért azonnal alkalmasak a padlószőnyeg,
          parketta, hidegburkolatok vagy habszivacsos PVC burkolatok fogadására. Gazdaságossága bizonyított, hiszen
          pénzt és időt takaríthatunk meg, azzal, hogy egy munkafázist kihagyhatunk, valamint nincs szükség a drága
          kiegyenlítőkre sem. Műszakilag jobb megoldást érünk el. Az estrich gazdaságosan alkalmazható lakóépületekben,
          családi házakban, irodaépületekben és közintézményekben is.
        </p>
        <p>
          <strong>Estrich betonok hagyományos anyagból:</strong>
        </p>
        <p>
          Helyszínen keverve maximum 0,4-0,8 mm-es szemnagyságú homokos kavicsból, cementből és speciális adalékokból,
          víz keverékéből készítjük. A munkaterületen belül történő szállítás egyedi estrich keverő és szállító pumpával
          történik. Bedolgozását kézi erővel, glettelését géppel vagy kézzel végezzük. A felhordott estrich minimális
          vastagsága 4 cm.
        </p>
        <p>
          <strong>Estrich betonok gyári előkevert anyagból:</strong>
        </p>
        <p>
          Az alapanyagot raklapon, zsákos kiszerelésben, vagy silóban szállítjuk a helyszínre. Előnye, hogy 2 cm
          vastagságtól alkalmazható, ezáltal kisebb a zsugorodási repedések kialakulásának a veszélye. Az anyag
          minőségének ellenőrzése folyamatosan történik, gyári laboratóriumban folyamatosan ügyelve a teljes
          homogenitásra. Az építési helyszínen kisebb az anyagtárolás helyigénye.
        </p>
        <p>
          <strong>Önterülő estrichek:</strong>
        </p>
        <p>
          A gyárilag előkevert anyagot a speciálisan az önterülő esztrich feldolgozására készített gép segítségével
          keverjük össze vízzel és juttatjuk el a bedolgozás helyszínére. A megfelelő konzisztencia beállítására
          használjuk a terülésmérő hengert. Az elterített estrich bedolgozása bedolgozókerettel vagy estrich seprűvel
          történik.
        </p>
        <p>
          <strong>Ökocsend szigetelés:</strong>
        </p>
        <p>
          Polisztirol gyöngy szigetelés, hozzáadott adalékkal kerül bedolgozásra. 100%-os szigetelést biztosít, még a
          problémás helyeken is. A padlóra szerelt csöveknél nincs munkahézag, folyamatos és zárt. Ez egységesebb
          felületet ad és minőségileg sokkal jobb réteget biztosít, mint a hagyományos táblás szigetelés.
        </p>
      </Section>
      <Section>
        <SubTitle id="falszigeteles">Utólagos falszigetelések</SubTitle>
        <p>
          Az utólagos falszigetelés célja, hogy a már beázott vagy salétromos falakon megállítsuk a vizesedést és
          megszüntessük az esetleges penészedéssel járó kellemetlen tüneteket, sókivirágzást. Helyreállítjuk a
          megrongálódott falrészt, ezzel is elősegítve a további állapotromlást.
        </p>
        <p>A probléma orvosolható például:</p>
        <ul>
          <li>különböző vakolatrendszerek kiépítésével (WTA rendszerű vakolat)</li>
          <li>vegyi falszigetelési eljárásokkal </li>
          <li>vízhatlan szigetelést biztosító mechanikai védelemmel </li>
          <li>trapézlemez beütéssel</li>
          <li>különböző oldatok/ vegyi anyagok/ habarcs falba injektálásával.</li>
        </ul>
        <p>
          Szakembereink készséggel állnak az Ön rendelkezésére, helyszíni megtekintés után a legoptimálisabb
          beavatkozást javasolják.
        </p>
      </Section>
      <Section>
        <SubTitle id="veszelytelenites">Homlokzat veszélytelenítés, felújítás és karbantartási munkák</SubTitle>
        <p>
          Az épületek külső burkoló elemei, párkányai, vakolata, műkövei, homlokzati díszei, fa eresze, idővel
          elöregednek, a környezeti hatások miatt károsodnak. Ezek balesetveszélyt jelentenek, ezért célszerű a mielőbbi
          beavatkozás és a hiba elhárítása. Leggyakrabban előforduló problémák a következők lehetnek, melyekre gyors és
          költséghatékony megoldást kínálunk.
        </p>
        <ul>
          <li>épületrészek vakolatának javítása;</li>
          <li>díszstukkók megerősítése, javítása;</li>
          <li>erkélyszegélyek és egyéb homlokzati részek hibáinak kijavítása;</li>
          <li>ereszcsatorna karbantartása.</li>
        </ul>
        <p>
          A munkát követően karbantartási szolgáltatásunkat igénybe veheti, ami annyit jelent, hogy megegyezés szerinti
          időszakokban ellenőrizzük az épület állapotát és egyéb problémáit.
        </p>
        <ul>
          <li>Veszélytelenítés, vakolatpótlás</li>
          <li>Vakolt homlokzat festése, impregnálása </li>
          <li>Épület festés</li>
          <li>Épület festés hőszigetelő festékkel</li>
          <li>Épület szigetelés</li>
          <li>Sérült vakolat javítása speciális anyaggal</li>
          <li>Műkő szerkezetek javítsa (vízorrok, erkélyszegélyek pótlása)</li>
          <li>Gipsz stukkó, műemlékjavítás, veszélyes elemek eltávolítása</li>
          <li>Lichthóf veszélytelenítése, javítása</li>
          <li>Homlokzat tisztítás. Vízzel, homokszórással.</li>
        </ul>
      </Section>
      <Section>
        <SubTitle id="kepek">Képek</SubTitle>
        <Images>
          <img src={i00065} alt="" />
          <img src={i00066} alt="" />
          {/* <img src={i00067} alt="" /> */}
          <img src={i00068} alt="" />
          {/* <img src={i00069} alt="" /> */}
          <img src={i00070} alt="" />
          <img src={i00071} alt="" />
          <img src={i00072} alt="" />
          <img src={i00001} alt="" />
          <img src={i00002} alt="" />
          <img src={i00004} alt="" />
          <img src={i00005} alt="" />
          <img src={i00006} alt="" />
          <img src={i00007} alt="" />
          <img src={i00008} alt="" />
          <img src={i00009} alt="" />
          <img src={i00010} alt="" />
          <img src={i00011} alt="" />
          <img src={i00012} alt="" />
          <img src={i00013} alt="" />
          <img src={i00014} alt="" />
          <img src={i00015} alt="" />
          <img src={i00016} alt="" />
          <img src={i00017} alt="" />
          <img src={i00018} alt="" />
          <img src={i00019} alt="" />
          <img src={i00020} alt="" />
          <img src={i00021} alt="" />
          <img src={i00022} alt="" />
          <img src={i00023} alt="" />
          <img src={i00024} alt="" />
          <img src={i00025} alt="" />
          <img src={i00026} alt="" />
          <img src={i00027} alt="" />
          <img src={i00028} alt="" />
          <img src={i00029} alt="" />
          <img src={i00030} alt="" />
          <img src={i00031} alt="" />
          <img src={i00032} alt="" />
          <img src={i00033} alt="" />
          <img src={i00034} alt="" />
          <img src={i00035} alt="" />
          <img src={i00036} alt="" />
          <img src={i00037} alt="" />
          <img src={i00038} alt="" />
          <img src={i00039} alt="" />
          <img src={i00040} alt="" />
          <img src={i00041} alt="" />
          <img src={i00042} alt="" />
          <img src={i00043} alt="" />
          <img src={i00044} alt="" />
          <img src={i00045} alt="" />
          <img src={i00046} alt="" />
          <img src={i00047} alt="" />
          <img src={i00048} alt="" />
          <img src={i00049} alt="" />
          <img src={i00050} alt="" />
          <img src={i00051} alt="" />
          <img src={i00052} alt="" />
          <img src={i00053} alt="" />
          <img src={i00054} alt="" />
          <img src={i00055} alt="" />
          <img src={i00056} alt="" />
          <img src={i00057} alt="" />
          <img src={i00058} alt="" />
          <img src={i00059} alt="" />
          <img src={i00060} alt="" />
          <img src={i00061} alt="" />
          <img src={i00062} alt="" />
          <img src={i00063} alt="" />
          <img src={i00064} alt="" />
        </Images>
        <ScrollIndicator>◀ ● ▶</ScrollIndicator>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
